import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';
import OrderPanelView from './panel-view';
import Loader from '../shared/loader';
import InfiniteScroller from '../shared/infinite-scroller';
import ListItem from './list-item';
import styles from './styles/list.scss';
import UserUtils from '../../services/user-utils';

class OrderList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayLoader: true,
            currentPage: 1,
        };

        document.title = this.props.intl.formatMessage({ id: 'yourOrders', defaultMessage: 'Your Orders' });
        this.loadMore = this.loadMore.bind(this);
    }

    componentDidMount() {
        if (UserUtils.isLoggedIn()) {
            this.props.loadOrders(this.props.access_token, this.state.currentPage, this.props.locale)
                .then((response) => {
                    this.setState({ displayLoader: false });
                }).catch((error) => {
                    console.log(error);
                });
        } else {
            this.props.handleUserNotLoggedIn();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'yourOrders', defaultMessage: 'Your Orders' });
            this.props.loadOrders(this.props.access_token, this.state.currentPage, this.props.locale);
        }
    }

    loadMore() {
        this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));

        return this.props.loadOrders(this.props.access_token, this.state.currentPage, this.props.locale);
    }

    render() {
        const orderListMarkup = this.props.orders.map((order, idx) => (
            <div key={idx} className={styles.listItem}>
                <ListItem order={{ ...order, ...order.attributes }} stores={this.props.stores} locale={this.props.locale} />
                {/* <OrderPanelView order={{ ...order, ...order.attributes }} stores={this.props.stores} /> */}
            </div>
        ));

        return (
            <Layout>
                <div className="order-list-page order-section">
                    <div className="container">
                        <div
                            className={`section-heading text-center ${styles.header}`}
                        >
                            <FormattedMessage id="myOrders" defaultMessage="My Orders" />
                        </div>
                        <Loader displayLoader={this.state.displayLoader} />
                        <div className={`row hidden-xs hidden-sm hidden-md ${styles.tableHeader}`}>
                            <div className="col-lg-2 text-center font-weight-bold">
                                <FormattedMessage id="order-number" defaultMessage="#Order" />
                            </div>
                            <div className="col-lg-2 text-center font-weight-bold">
                                <FormattedMessage id="order-date" defaultMessage="Order Date" />
                            </div>
                            <div className="col-lg-2 text-center font-weight-bold">
                                <FormattedMessage id="order-state" defaultMessage="Order State" />
                            </div>
                            <div className="col-lg-2 text-center font-weight-bold">
                                <FormattedMessage id="destiny" defaultMessage="Destiny" />
                            </div>
                            <div className="col-lg-2 text-center">
                                <FormattedMessage id="order-total" defaultMessage="Total Payment" />
                            </div>
                            <div className="col-lg-2 text-center" />
                        </div>
                        <div className="product-infinite-scroll">
                            <InfiniteScroller loadMore={this.loadMore} pageCount={this.props.pageCount} currentPage={this.state.currentPage}>
                                <div className="confirmation-details-block">
                                    <div className={`checkout-block-content ${styles.orderList}`}>
                                        {orderListMarkup}
                                    </div>
                                </div>
                            </InfiniteScroller>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(OrderList);



/** WEBPACK FOOTER **
 ** ./src/components/order/list.jsx
 **/